import { REGIONS } from 'consts';

import { TFieldProps } from 'types';

export const fields: TFieldProps[] = [{
  type: TFieldProps.type.Text,
  name: 'name',
  label: 'Internal Name',
  rules: [{
    message: 'Internal Name is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.ImageUpload,
  name: 'imageMetadataId',
  label: 'Product Image',
  entityType: 'PRODUCT',
}, {
  type: TFieldProps.type.Text,
  name: 'sponsorCode',
  label: 'Sponsor Code',
  rules: [{
    message: 'Sponsor Code is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Text,
  name: 'productId',
  label: 'Product ID',
  rules: [{
    message: 'Product ID is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.DateDiapasons,
  name: 'effectivePeriods',
  label: 'Next Activity Period',
}, {
  type: TFieldProps.type.TreeSelect,
  name: 'regions',
  label: 'Regions',
  treeData: REGIONS,
  maxTagCount: 2,
  maxTagPlaceholder: (omittedValues) => `+ ${omittedValues.length} Regions ...`,
  rules: [{
    type: 'array',
    min: 1,
    required: true,
    message: 'Select minimum 1 region!',
  }],
}, {
  type: TFieldProps.type.Number,
  name: 'receiptAcceptanceDaysThreshold',
  label: 'Days Threshold',
  precision: 0,
}];
